import React, { useState } from "react";
import "../../styles/Listing.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import ResidentialPurchase from "../../components/Checklists/Saskatchewan/ResidentialPurchase.js";
import PreConPurchase from "../../components/Checklists/Saskatchewan/PreConPurchase.js";
import AssignmentPurchase from "../../components/Checklists/Saskatchewan/AssignmentPurchase.js";

export default function Purchase() {
  const [PurchaseType, setPurchaseType] = useState("");

  let PurchaseTemplate = "";
  if (PurchaseType === "Residential") {
    PurchaseTemplate = <ResidentialPurchase />;
  } else if (PurchaseType === "PreCon") {
    PurchaseTemplate = <PreConPurchase />;
  } else if (PurchaseType === "Assignment") {
    PurchaseTemplate = <AssignmentPurchase />;
  } else {
    PurchaseTemplate = "";
  }

  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const setCheckList = (e) => {
    setPurchaseType(e.target.value);
  };

  return (
    <div className="checklists flex flex-col items-center justify-center">
      <div className="flex flex-col w-full pl-4 ">
        <div className="flex flex-col items-left pb-2">
          <ThemeProvider theme={theme}>
            <FormControl sx={{ mt: 1, minWidth: 325, maxWidth: 110 }}>
              <InputLabel size="small" className="select-default-label">
                Purchase Type
              </InputLabel>
              <Select
                value={PurchaseType}
                name="Purchase Type"
                label="Purchase Type"
                onChange={setCheckList}
                size="small"
                sx={{ borderRadius: 20 }}
              >
                <MenuItem key={Math.random()} value="Residential">
                  Residential
                </MenuItem>
                <MenuItem key={Math.random()} value="PreCon">
                  Pre-Construction
                </MenuItem>
                <MenuItem key={Math.random()} value="Assignment">
                  Assignment
                </MenuItem>
              </Select>
            </FormControl>
          </ThemeProvider>
        </div>
      </div>
      {PurchaseTemplate}
    </div>
  );
}
